import { render, staticRenderFns } from "./moreDetail.vue?vue&type=template&id=400d8c59&scoped=true&"
import script from "./moreDetail.vue?vue&type=script&lang=js&"
export * from "./moreDetail.vue?vue&type=script&lang=js&"
import style0 from "./moreDetail.vue?vue&type=style&index=0&id=400d8c59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d8c59",
  null
  
)

export default component.exports